import { Box, CircularProgress, Container, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import { resolve } from 'path-browserify';
import React from 'react'
import { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes';
import readXlsFile from 'read-excel-file';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


class MarcasMensual extends Component {
    constructor(props){
        super(props);
        this.state = {
            archivo: '',
            prueba: '',
            loading: false,
        }
        this.manejarCambiosDatosArchivo = this.manejarCambiosDatosArchivo.bind(this);
        this.manejarEnvioArchivo = this.manejarEnvioArchivo.bind(this);

    }
    render(){
        return (
            <>
                <Container>
                    <h3>Carga Marcas Manual Mensual</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    <Container>        
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={2.5}>
                                    <Item>Cargar Excel</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}/>
                                </Grid>
                                <Grid item xs={2}>
                                    
                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioArchivo}>Enviar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                </Container>
            </>
        )
    }

    manejarCambiosDatosArchivo(e){
        e.preventDefault();
        let valor = e.target.files[0];
        readXlsFile(valor).then((rows) => {
            this.setState({
                archivo: rows,
                prueba: rows[1],
            })
        });
    }

    async manejarEnvioArchivo(e){
        e.preventDefault();
        this.setState({
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.archivo]);

        const control = await fetch(`${Constantes.RUTA_API}/cargar_marcasManualMensual.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: res[1],
                loading: false,
            });
        }
    }
}

export default MarcasMensual